import {
  type TextFieldProps,
  Stack,
  InputLabel,
  TextField,
} from '@mui/material'

export function InputField({
  label,
  sx,
  ...props
}: Omit<TextFieldProps, 'label'> & { label?: string }) {
  const inputId = props.id ?? label

  return (
    <Stack spacing={1}>
      {label ? <InputLabel htmlFor={inputId}>{label}</InputLabel> : null}
      <TextField
        variant="outlined"
        id={inputId}
        size="small"
        sx={{
          background: '#FAFAFA',
          ...(sx as object),
        }}
        {...props}
      />
    </Stack>
  )
}
